module.exports = __webpack_public_path__ + "static/media/ZoneA.104eb150.png";